export const NUTRITION_PLAN_DRAG_TYPE_MEAL = "nutrition-plan-meal";

export function getNutritionPlanMealSortableId(mealId) {
  return `nutrition-plan-meal:${String(mealId ?? "").trim()}`;
}
